import React from 'react'
import { Button, Spinner, ButtonProps } from 'react-bootstrap'
import styled from 'styled-components'

interface WmsActionButtonProps extends ButtonProps {
  isLoading: boolean
  onClick: () => void
  className?: string
}

const StyledWmsActionButton = styled(({ className, ...props }: ButtonProps) => (
  <Button className={className} {...props} />
))`
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  padding: 10px 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
`

const WmsActionButton: React.FC<WmsActionButtonProps> = ({
  isLoading,
  onClick,
  className,
  ...props
}) => {
  return (
    <StyledWmsActionButton
      variant="success"
      size="lg"
      onClick={onClick}
      disabled={isLoading}
      className={className}
      {...props}
    >
      {isLoading ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
          Loading WMS Image...
        </>
      ) : (
        <>
          <i className="bi bi-cloud-download me-2"></i>
          Get WMS Image
        </>
      )}
    </StyledWmsActionButton>
  )
}

export default WmsActionButton
